import { useMemo } from 'react';
import { createQuarterlyData, round2 } from './useQuarterHelpers';

/**
 * Calcul des factures et reste à facturer par consultant
 */
export function useFacturesCalculations(facturesInternes, caNet) {
  const factures = useMemo(() => {
    const result = {};

    facturesInternes.forEach(facture => {
      const consultant = facture.consultantNom;
      if (!consultant) return;

      if (!result[consultant]) {
        result[consultant] = createQuarterlyData();
      }

      const trimestre = facture.fields?.Trimestre;
      if (!trimestre) return;

      const montant = facture.fields?.['Montant total (HT)'] || 0;

      result[consultant][trimestre] += montant;
      result[consultant].ANNUEL += montant;
    });

    return result;
  }, [facturesInternes]);

  const reste = useMemo(() => {
    const result = {};

    Object.keys(caNet).forEach(consultant => {
      const facturesConsultant = factures[consultant] || createQuarterlyData();

      result[consultant] = {
        Q1: round2(caNet[consultant].Q1 - facturesConsultant.Q1),
        Q2: round2(caNet[consultant].Q2 - facturesConsultant.Q2),
        Q3: round2(caNet[consultant].Q3 - facturesConsultant.Q3),
        Q4: round2(caNet[consultant].Q4 - facturesConsultant.Q4),
        ANNUEL: round2(caNet[consultant].ANNUEL - facturesConsultant.ANNUEL)
      };
    });

    return result;
  }, [caNet, factures]);

  return { factures, reste };
}
